import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { DESIGNATION_ROUTE } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, DELETE, PUT } = HTTP_METHODS;
const { GET_DESIGNATION } = DESIGNATION_ROUTE;

export const designationApi = createApi({
  reducerPath: 'designationApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getDesignation: builder.query({
      query: (data) => ({ url: `${GET_DESIGNATION}${buildQueryString(data)}`, method: GET })
    }),
    getDesignationById: builder.query({
      query: (id) => ({
        url: `${GET_DESIGNATION}/${id}`,
        method: GET
      })
    }),
    addDesignation: builder.mutation({
      query: (data) => ({ url: `${GET_DESIGNATION}`, method: POST, data })
    }),
    deleteDesignation: builder.mutation({
      query: (id) => ({
        url: `${GET_DESIGNATION}/${id}`,
        method: DELETE
      })
    }),
    editDesignation: builder.mutation({
      query: (data) => ({
        url: `${GET_DESIGNATION}/${data.id}`,
        method: PUT,
        data: data?.data
      })
    })
  })
});

export const {
  useGetDesignationQuery,
  useGetDesignationByIdQuery,
  useAddDesignationMutation,
  useDeleteDesignationMutation,
  useEditDesignationMutation
} = designationApi;
